export default function voyageTweaksDataToJson(tweaks) {
    return {
        mesh_spacing_distance: tweaks.meshSpacingDistance,
        mesh_speed_distance: tweaks.meshSpeedDistance,
        mesh_width: tweaks.meshWidth,
        optimisation_mode: tweaks.optimisationMode,
        solutions_limit: tweaks.solutionsLimit,
        reduce_mesh_to_base_route: tweaks.reduceMeshToBaseRoute,
    };
}